'use client';
import { fetchPost } from 'eco-design-micro/request/FetchClient';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type.d';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

export const sendMultiEmarsysEmail = async (locale: string, data: any, subscribeData?: CookieDataExtendType | undefined) => {
    const obj = {
        sector_name: 'Banner',
        entry_position: 1,
    } as CookieDataExtendType;

    if (subscribeData) {
        (Object.keys(subscribeData) as Array<keyof CookieDataExtendType>)?.map((k: keyof CookieDataExtendType) => {
            if (k && subscribeData[k]) {
                obj[k] = subscribeData[k];
            }
        });
    }

    const res = await fetchPost(`/subscribe/new`, locale, subscribeData ? { ...data, eventTracking: subscribeCookie(obj) } : data, {
        headers: {
            // apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
        },
    });
    return res;
};
